module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto",
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "width": "100%",
      "height": "20px",
      "background-color": "#ddd"
    }
  }, [_vm._v("\n    szukaj.\n  ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover"
  }, [_c('tbody', _vm._l((_vm.options), function(option) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(option.label))])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-afcd446a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TableInput.vue
// module id = 466
// module chunks = 1